function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import fetch from '@rd-web-markets/shared/dist/services/Fetcher';
import { request } from '@rd-web-markets/shared/dist/services/request';
import { ApiError } from '@rd-web-markets/shared/dist/services/ApiError';
const commentsService = {
  async all(object_id, object_type, span_id, field) {
    try {
      // we can fetch comments even without a span id
      let query = "/api/comments?object_type=".concat(object_type, "&object_id=").concat(object_id, "&field=").concat(field);
      if (span_id) {
        query = "".concat(query, "&span_id=").concat(span_id);
      }
      return await fetch(query, request.get);
    } catch (error) {
      if (error.message.includes('Change set must exist')) {
        throw new ApiError('Change set does not exist. Make sure the claim group is under manager QA review to use the comments functionality.');
      }
    }
  },
  create(object_id, object_type, comment) {
    return fetch('/api/comments', _objectSpread(_objectSpread({}, request.post), {}, {
      body: JSON.stringify({
        object_id,
        object_type,
        comment
      })
    }));
  }
};
export default commentsService;